import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./location_recommendations_level.js";
//#region src/location_recommendations_level_helper.ts
var location_recommendations_level_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(recommendationsLevel) {
	switch (recommendationsLevel) {
		case 0: return "No Recommendations";
		case 1: return "Passive (Show at bottom)";
		case 2: return "Active (Always visible)";
		case 3: return "Mods Only (Vitrine only!)";
	}
}
//#endregion
export { location_recommendations_level_helper_exports, name };

//# sourceMappingURL=location_recommendations_level_helper.js.map